import React, { useState, useEffect, useMemo } from 'react';
import { Link } from 'react-router';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Select } from '../components/ui/Select';
import { cierres as initialCierres, agentes } from '../utils/mockData';
import { exportarCierresExcel } from '../utils/exportHelpers';
import {
  FileDown,
  CalendarPlus,
  Eye,
  Edit,
  AlertCircle,
  CheckCircle,
  TrendingUp,
  TrendingDown,
  Loader,
  CircleDollarSign,
  CirclePlus,
  Paperclip,
  MessageCirclePlus
} from 'lucide-react';

import { CierreAgenteService } from '../services/cierreAgenteService';
import EditarSaldo from '../modals/EditarSaldo';
import AgregarObservacion from '../modals/AgregarObservacion';
import CambiosCierre from '../modals/CambiosCierre';
import { useToast } from "../components/ui/toast-provider";
import DetalleCierres from '../modals/DetalleCierres';
import { AgenteService } from '../services/agenteService';
// Tipos de Response
import { AgenteResponse } from '../types/agente';
import DetalleCambiosCierre from '../modals/CambiosCierre';
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import LogoNombre from '../components/img/LogoNombre.png';

interface EstadoOption {
  id: number;
  valor: string;
}

export function AdminDashboard() {
  const [cierres, setCierres] = useState(initialCierres);
  const [filtroFecha, setFiltroFecha] = useState('');
  const [filtroFechaFin, setFiltroFechaFin] = useState('');
  const [filtroAgente, setFiltroAgente] = useState('');
  const { addToast } = useToast();

  const [resumen, setResumen] = useState<any>(null);
  const [resumenFechas, setResumenFechas] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [error2, setError2] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading2, setIsLoading2] = useState(true);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [mostrarCambiosCierre, setMostrarCambiosCierre] = useState(false);
  const [CierreEditando, setCierreEditando] = useState<Number>(0);
  const [agenteMonto, setAgenteMonto] = useState<Number>(0);
  const [fechaBuscar, setFechaBuscar] = useState("");
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [agenteDetalle, setAgenteDetalle] = useState<Number>(0);
  const [idBuscar, setIdBuscar] = useState<Number>(0);

  const tableRef = useRef<HTMLDivElement | null>(null);
  const tableRef2 = useRef<HTMLDivElement | null>(null);

  const handlePrint = useReactToPrint({
    contentRef: tableRef,
    documentTitle: "Reporte de Cierres Del Día",
    pageStyle: `
      @page {
        size: landscape;
        margin: 10mm;
      }

      @media print {
        div {
          overflow: visible !important;
          max-height: none !important;
        }

        table {
          width: 100% !important;
          border-collapse: collapse;
        }

        thead {
          position: static !important;
        }

        tr {
          page-break-inside: avoid;
        }
      }

      * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
      }
    `,
  });

  const handlePrint2 = useReactToPrint({
    contentRef: tableRef2,
    documentTitle: "Reporte de Cierres Generales",
    pageStyle: `
      @page {
        size: landscape;
        margin: 10mm;
      }

      @media print {
        div {
          overflow: visible !important;
          max-height: none !important;
        }

        table {
          width: 100% !important;
          border-collapse: collapse;
        }

        thead {
          position: static !important;
        }

        tr {
          page-break-inside: avoid;
        }
      }

      * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
      }
    `,
  });

  const [agentes, setAgentes] = useState<AgenteResponse[]>([]);
  const estados: EstadoOption[] = [
    { id: 1, valor: "Cuadrado" },
    { id: 2, valor: "Faltante" },
    { id: 3, valor: "Sobrante" },
    { id: 4, valor: "Pendiente" }
  ];

  const sobregirados: EstadoOption[] = [
    { id: 1, valor: "Sobregirado" },
    { id: 2, valor: "No Sobregirado" }
  ];

  const [filtroEstado, setFiltroEstado] = useState<number | "">("");
  const [filtroSobregirado, setFiltroSobregirado] = useState<number | "">("");

  const getEstadoColor = (estado: string) => {
    switch (estado) {
      case 'Cuadrado':
        return 'text-accent';
      case 'Faltante':
        return 'text-destructive';
      case 'Sobrante':
        return 'text-[#dea753]';
      case 'Pendiente':
        return 'text-muted-foreground';
      default:
        return 'text-foreground';
    }
  };

  const getEstadoIcon = (estado: string) => {
    switch (estado) {
      case 'Cuadrado':
        return <CheckCircle className="w-4 h-4" />;
      case 'Faltante':
        return <TrendingDown className="w-4 h-4" />;
      case 'Sobrante':
        return <TrendingUp className="w-4 h-4" />;
      case 'Pendiente':
        return <AlertCircle className="w-4 h-4" />;
      default:
        return null;
    }
  };

  const getResumen = async () => {
    try {
      setError("");
      const res = await CierreAgenteService.getResumenDasboard();
      setResumen(res.data);

      //console.log("Este es el resumen: ", res.data)
    } catch (err) {
      setError("Error al cargar empleados");
    } finally {
      setIsLoading(false);
    }

  }

  useEffect(() => {
    getResumen();
    getAgentes();
  }, []);

  useEffect(() => {
    getResumenFechas();
  }, [filtroFecha, filtroFechaFin])

  const getAgentes = async () => {
    try {
      setError2("");
        const res = await AgenteService.getToditos();
        setAgentes(res.data);

    } catch (err) {
      setError2("Error al cargar agentes");
    } finally {
      setIsLoading2(false);
    }
  }

  const getResumenFechas = async () => {
    try {
      setError2("");

      if(filtroFecha.length == 0 || filtroFechaFin.length == 0){
        setResumenFechas(null);
        return;
      }else{
        const res = await CierreAgenteService.getCierresRango(filtroFecha, filtroFechaFin);
        setResumenFechas(res.data);
        //console.log(res.data);
      }

    } catch (err) {
      setError2("Error al cargar cierres en el rango ingresado");
    } finally {
      setIsLoading2(false);
    }

  }

  const exportarExcelHoy = () => {
    if (!resumen?.agentes || resumen.agentes.length === 0) {
      addToast("No hay datos para exportar");
      return;
    }
    
    exportarCierresExcel(resumen.agentes);
  };

  const exportarExcelRango = () => {
    if (!resumenFechasFiltrado || resumenFechasFiltrado.length === 0) {
      addToast("No hay datos para exportar");
      return;
    }
    
    exportarCierresExcel(resumenFechasFiltrado);
  };

  const cambiarEstado = async (idSaldoSistema: number, version: number, idAgente: number) => {
    try {
      setIsLoading(true);
      if(version == 3){
        await CierreAgenteService.crear({
            saldo: 1,
            idAgente: idAgente,            
        });
        addToast("Edición activada para el cierre");
      }else{
        await CierreAgenteService.activar(idSaldoSistema);
        addToast("Edición activada para el cierre");
      }
    } catch (err) {
      setError("Error al cambiar estado del cierre");
    } finally {
      setIsLoading(false);
    }
  };

  const estadisticas = {
    totalCierres: 0,
    cuadrados: 0,
    faltantes: 0,
    sobrantes: 0,
    sobregirados: 0
  };

  const resumenFechasFiltrado = useMemo(() => {
    if (!resumenFechas?.agentes) return [];

    let data = [...resumenFechas.agentes];

    // Filtrar por agente
    if (filtroAgente) {
      data = data.filter(
        (a: any) => a.idAgente === Number(filtroAgente)
      );
    }

    // Filtrar por estado    
    if (filtroEstado) {
      data = data.filter(
        (a: any) => a.estado === estados.find(e => e.id === Number(filtroEstado))?.valor
      );
    }

    // Filtrar por sobregirado   
    if (filtroSobregirado !== "") {
      const esSobregirado = filtroSobregirado === 1;

      //console.log("SABRÁ DIOS: ", esSobregirado)

      data = data.filter(
        (a: any) => a.sobregirado === esSobregirado
      );
    }

    // Filtrar por Id
    if (idBuscar!=0) {
      data = data.filter(
        (a: any) => a.idCierreAgente === Number(idBuscar)
      );
    }

    // Ordenar por fecha DESC (más reciente primero)
    data.sort(
      (a: any, b: any) =>
        new Date(b.fecha).getTime() - new Date(a.fecha).getTime()
    );

    estadisticas.totalCierres = data.length;
    estadisticas.cuadrados = data.filter((c: any) => c.estado === 'Cuadrado').length;
    estadisticas.faltantes = data.filter((c: any) => c.estado === 'Faltante').length;
    estadisticas.sobrantes = data.filter((c: any) => c.estado === 'Sobrante').length;
    estadisticas.sobregirados = data.filter((c: any) => c.sobregirado === true).length;

    return data;
  }, [resumenFechas, filtroAgente, filtroEstado, filtroSobregirado, idBuscar, filtroFecha, filtroFechaFin]);

  const getColorDiferencia = (diferencia: number) => {
    if (diferencia === 0) return "text-accent";
    if (Math.abs(diferencia) < 10) return "text-muted-foreground";
    if (Math.abs(diferencia) < 100) return "text-[#dea753]";
    return "text-destructive";
  };

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-6 md:grid-cols-6 gap-4 p-6 text-primary bg-white items-center">
        {/* Logo */}
        <div className="col-span-2 md:col-span-1 flex justify-center md:justify-start">
            <img 
            src={LogoNombre} 
            alt="Logo AGEMI" 
            className="w-30 md:w-50 h-auto object-contain"
            />
        </div>
        <div className="col-span-4 md:col-span-5 flex flex-col text-sm md:text-base">
          <h1 className="text-3xl font-bold">Dashboard de Administración</h1>
        <p className="text-base text-muted-foreground mt-1 md:mt-2">
          Gestión y monitoreo de cierres de caja de todos los agentes
        </p>
        </div>
      </div>

      {/* Tabla de Cierres */}
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2 b-2">
            <div className="grid grid-cols-6 md:grid-cols-6 gap-4 p-5 md:p-3 text-white bg-primary border border-primary rounded-t-lg items-center print:visible">
                {/* Logo */}
                <div className="col-span-1 flex justify-center md:justify-start">
                  <Paperclip className="w-10 h-10 md:w-10 md:h-10 text-accent" />
                  {/*
                    <img 
                    src={LogoBlanco} 
                    alt="Logo AGEMI" 
                    className="w-20 md:w-40 h-auto object-contain"
                    /> */}
                </div>
                <div className="col-span-5 flex flex-col text-sm md:text-base">
                  <h1 className="text-2xl md:text-3xl font-bold">Resumen del Día</h1>
                <p className="text-sm md:text-base text-white mt-1 md:mt-2">
                  Registro diario de cierres de caja de todos los agentes
                </p>
                </div>
            </div>
          </div>
        </CardHeader>
        <CardContent>

          <div className="flex items-start justify-start mb-4 gap-2">
            <Button onClick={() => {
              document.title = `REPORTE_CIERRES_${new Date()
                .toLocaleDateString('es-GT')
                .replaceAll('/', '-')}`;

              handlePrint();
            }} variant="primary" className="flex-1 md:flex-none">
              <FileDown className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Exportar PDF</span>
              <span className="sm:hidden">PDF</span>
            </Button>
            <Button onClick={exportarExcelHoy} variant="accent" className="flex-1 md:flex-none">
              <FileDown className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Exportar Excel</span>
              <span className="sm:hidden">Excel</span>
            </Button>
          </div>

          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader className="w-6 h-6 animate-spin text-primary mr-2" />
              <p>Cargando cierres...</p>
            </div>
          ) : resumen?.agentes?.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-muted-foreground">No hay cierres para mostrar</p>
            </div>
          ) : (
            
            <div className="overflow-auto max-h-[400px] border-gray-400 mb-10" ref={tableRef}>
              <div className="hidden print:block">
                <div className="grid grid-cols-6 gap-4 p-6 text-primary bg-white mb-5 items-center">
                  {/* Logo */}
                  <div className="col-span-1 flex justify-center md:justify-start">
                      <img 
                      src={LogoNombre} 
                      alt="Logo AGEMI" 
                      className="w-40 h-auto object-contain"
                      />
                  </div>
                  <div className="col-span-5 flex flex-col text-sm md:text-base">
                    <h1 className="text-3xl font-bold">Resumen del Día</h1>
                  <p className="text-base text-muted-foreground mt-1 md:mt-2">
                    Registro diario de cierres de caja de todos los agentes
                  </p>
                  </div>
                </div>
              </div>
                <table className="min-w-full text-left">
                  <thead className="sticky top-0 z-20 bg-primary text-white">
                    <tr>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Usuario</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Agente</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Fecha</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Hora</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Saldo Caja</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Boleta Bancaria</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Saldo Sistema</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Estado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Sobregirado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Diferencia</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Ediciones</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-center font-semibold print:hidden">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumen?.agentes?.map((agente: any, index: number) => (
                      <tr key={`cierre-${agente.idCierreAgente}-${index}`} className="border-t border-border hover:bg-muted/30 transition-colors">
                        <td className="px-3 md:px-4 py-2 md:py-3 font-medium text-xs md:text-sm">
                          <div className="truncate">{agente.usuario}</div>
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.agente}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.fecha.slice(0,10).split("-").reverse().join("/")}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.hora}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">
                            Q{agente.saldoEnCaja.toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">
                          Q{(agente.saldoBoletas).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">Q{(agente.saldoSistema).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm font-semibold">
                          <div
                            className={`flex items-center justify-center gap-1 md:gap-2 text-xs md:text-sm ${getEstadoColor(
                              agente.estado
                            )}`}
                          >
                            {getEstadoIcon(agente.estado)}
                            {agente.estado}
                          </div>
                        </td>
                        <td className={`px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm font-semibold ${agente.sobregirado ? "text-destructive" : "text-muted-foreground"}`}>
                            {agente.sobregirado ? "Sobregirado" : "No aplica"}
                        </td>
                        <td className={`px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm ${getEstadoColor(
                              agente.estado
                            )}`}>
                          Q{agente.diferencia != null && agente.diferencia > 0 ? '+' : ''}{(agente.diferencia ?? 0).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">
                          {agente.version}
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 print:hidden">
                          <div className="flex justify-center gap-1 md:gap-2">
                            <Button
                              size="sm"
                              variant="accent"
                              className="text-xs md:text-sm px-2 md:px-3"
                              disabled = {agente.version!=0 ? false : true}
                              onClick={() => {
                                setCierreEditando(agente.idCierreAgente)
                                setMostrarFormulario(true);
                              }}
                            >
                              <MessageCirclePlus size={16} />
                            </Button>
                            <Button
                              size="sm"
                              variant="primary"
                              className="text-xs md:text-sm px-2 md:px-3"
                              disabled = {agente.version>=3 ? false : true}
                              onClick={() => {
                                cambiarEstado(agente.idSaldoSistema, agente.version, agente.idAgente)
                              }}
                            >
                              <CirclePlus size={16} />
                            </Button>
                            <Button
                              size="sm"
                              variant="warning"
                              className="text-xs md:text-sm px-2 md:px-3"
                              disabled = {agente.version!=0 ? false : true}
                              onClick={() => {
                                setAgenteDetalle(agente.idAgente);
                                setAgenteMonto(Number(agente.monto))
                                setMostrarDetalle(true);
                              }}
                            >
                              <Eye size={16} />
                            </Button>
                            <Button
                              size="sm"
                              variant="primary"
                              className="text-xs md:text-sm px-2 md:px-3"
                              onClick={() => {
                                setAgenteDetalle(agente.idAgente);
                                setMostrarCambiosCierre(true);
                              }}
                            >
                              <CalendarPlus size={16} />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
            </div>
          )}

          {error && (
            <div className="p-4 mt-4 bg-destructive/10 border border-destructive rounded-lg text-destructive flex items-start gap-2">
              <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold">Error al cargar cierres</p>
                <p className="text-sm">{error}</p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      {/* Filtros y Exportación */}
      <Card>
        <CardHeader>
          <div className="flex items-center gap-2 mb-5">
            <div className="grid grid-cols-6 md:grid-cols-6 gap-4 p-5 md:p-3 text-white bg-primary border border-primary rounded-t-lg items-center print:visible">
                {/* Logo */}
                <div className="col-span-1 flex justify-center md:justify-start">
                  <Paperclip className="w-10 h-10 md:w-10 md:h-10 text-accent" />
                  {/*
                    <img 
                    src={LogoBlanco} 
                    alt="Logo AGEMI" 
                    className="w-20 md:w-40 h-auto object-contain"
                    /> */}
                </div>
                <div className="col-span-5 flex flex-col text-sm md:text-base">
                  <h1 className="text-2xl md:text-3xl font-bold">Cierres Generales</h1>
                <p className="text-sm md:text-base text-white mt-1 md:mt-2">
                  Registros de cierres de caja de todos los agentes
                </p>
                </div>
            </div>
          </div>
          {/* Estadísticas */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2 md:gap-4">
            <Card>
              <CardContent className="p-3 md:p-6">
                <div className="text-xl md:text-2xl font-bold text-primary">{estadisticas.totalCierres}</div>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">Cierres</p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-3 md:p-6">
                <div className="text-xl md:text-2xl font-bold text-accent">{estadisticas.cuadrados}</div>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">Cuadrados</p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-3 md:p-6">
                <div className="text-xl md:text-2xl font-bold text-destructive">{estadisticas.faltantes}</div>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">Faltantes</p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-3 md:p-6">
                <div className="text-xl md:text-2xl font-bold text-[#dea753]">{estadisticas.sobrantes}</div>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">Sobrantes</p>
              </CardContent>
            </Card>
            <Card>
              <CardContent className="p-3 md:p-6">
                <div className="text-xl md:text-2xl font-bold text-destructive">{estadisticas.sobregirados}</div>
                <p className="text-xs md:text-sm text-muted-foreground mt-1">Sobregirados</p>
              </CardContent>
            </Card>
          </div>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
            <Input
              label="Fecha Inicio"
              type="date"
              value={filtroFecha}
              onChange={(e) => setFiltroFecha(e.target.value)}
            />
            <Input
              label="Fecha Fin"
              type="date"
              value={filtroFechaFin}
              onChange={(e) => setFiltroFechaFin(e.target.value)}
            />
            <Select
              label="Filtrar por Agente"
              value={filtroAgente}
              onChange={(e) => setFiltroAgente(e.target.value)}
              options={agentes.map((a) => ({ value: (a.idAgente!).toString(), label: a.usuario }))}
              disabled={!resumenFechas}
            />
            <Select
              label="Filtrar por Estado"
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(Number(e.target.value))}
              options={estados.map((estado) => ({
                value: (estado.id).toString(),
                label: estado.valor
              }))}
              disabled={!resumenFechas}
            />
            <Select
              label="Filtrar por Sobregirado"
              value={filtroSobregirado}
              onChange={(e) => {
                const value = e.target.value;
                setFiltroSobregirado(value === "" ? "" : Number(value));
              }}
              options={sobregirados.map((estado) => ({
                value: (estado.id).toString(),
                label: estado.valor
              }))}
              disabled={!resumenFechas}
            />
            <Input
                label="Filtrar por Id"
                type="number"
                min="0"
                value={(idBuscar).toString()}
                onChange={(e) => setIdBuscar(Number(e.target.value))}
                placeholder="0"
                disabled={!resumenFechas}
              />
            <div className="flex items-end gap-2">
              <Button onClick={() => {
              document.title = `REPORTE_CIERRES_${new Date()
                .toLocaleDateString('es-GT')
                .replaceAll('/', '-')}`;

              handlePrint2();
            }} variant="primary" className="flex-1 md:flex-none">
              <FileDown className="w-4 h-4 mr-2" />
              <span className="hidden sm:inline">Exportar PDF</span>
              <span className="sm:hidden">PDF</span>
            </Button>
              <Button onClick={exportarExcelRango} variant="accent" className="flex-1 md:flex-none">
                <FileDown className="w-4 h-6 mr-2" />
                <span className="hidden sm:inline">Exportar Excel</span>
                <span className="sm:hidden">Excel</span>
              </Button>
            </div>
          </div>

          {isLoading2 ? (
            <div className="flex items-center justify-center py-8">
              <Loader className="w-6 h-6 animate-spin text-primary mr-2" />
              <p>Cargando cierres...</p>
            </div>
          ) : resumenFechas?.agentes?.length === 0 ? (
            <div className="text-center py-8">
              <p className="text-muted-foreground">No hay cierres para mostrar</p>
            </div>
          ) : (
            <div className="overflow-auto max-h-[400px] border-gray-400 mb-10 mt-5 " ref={tableRef2}>
              <div className="hidden print:block">
                <div className="grid grid-cols-6 gap-4 p-6 text-primary bg-white mb-5 items-center">
                  {/* Logo */}
                  <div className="col-span-1 flex justify-center md:justify-start">
                      <img 
                      src={LogoNombre} 
                      alt="Logo AGEMI" 
                      className="w-40 h-auto object-contain"
                      />
                  </div>
                  <div className="col-span-5 flex flex-col text-sm md:text-base">
                    <h1 className="text-3xl font-bold">Cierres Generales</h1>
                  <p className="text-base text-muted-foreground mt-1 md:mt-2">
                    Registros de cierres de caja de todos los agentes
                  </p>
                  <p className="text-base text-muted-foreground mt-1 md:mt-2">
                    Del {filtroFecha} al {filtroFechaFin}
                  </p>
                  </div>
                </div>
              </div>
                <table className="min-w-full text-left">
                  <thead className="bg-primary text-white sticky top-0">
                    <tr>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">ID</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Usuario</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Agente</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Fecha</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Fecha Creado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Hora Creado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Saldo Caja</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Boleta Bancaria</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Saldo Sistema</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Estado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Sobregirado</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Diferencia</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-left font-semibold">Ediciones</th>
                      <th className="px-3 md:px-4 py-2 md:py-3 text-center font-semibold print:hidden">Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resumenFechasFiltrado?.map((agente: any, index: number) => {
                      const serio = getColorDiferencia(agente.diferencia);
                      return (
                      <tr key={agente.idCierreAgente ?? `agente-${index}`} className="border-t border-border hover:bg-muted/30 transition-colors">
                        <td className="px-3 md:px-4 py-2 md:py-3 font-medium text-xs md:text-sm">
                          <div className="truncate">#CA-{agente.idCierreAgente}</div>
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 font-medium text-xs md:text-sm">
                          <div className="truncate">{agente.usuario}</div>
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.agente}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.fecha.slice(0,10).split("-").reverse().join("/")}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{new Date(agente.fechaUltimaActualizacion).toLocaleDateString('es-GT')}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">{agente.hora}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">Q{(agente.saldoEnCaja).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">Q{(agente.saldoBoletas).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }) || "0.00"}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">Q{(agente.saldoSistema).toLocaleString('es-GT', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            })}</td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm font-semibold">
                          <div
                            className={`flex items-center justify-center gap-1 md:gap-2 text-xs md:text-sm ${serio}`}
                          >
                            {getEstadoIcon(agente.estado)}
                            {agente.estado}
                          </div>
                        </td>
                        <td className={`px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm font-semibold ${agente.sobregirado ? "text-destructive" : "text-muted-foreground"}`}>
                            {agente.sobregirado ? "Sobregirado" : "No aplica"}
                        </td>
                        <td className={`px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm ${serio}`}>
                          {agente.diferencia != null && agente.diferencia > 0 ? '+' : ''}
                          Q{(agente.diferencia ?? 0).toLocaleString('es-GT', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })}
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 text-xs md:text-sm">
                          {agente.version}
                        </td>
                        <td className="px-3 md:px-4 py-2 md:py-3 print:hidden">
                          <div className="flex justify-center gap-1 md:gap-2">
                            <Button
                              size="sm"
                              variant="warning"
                              className="text-xs md:text-sm px-2 md:px-3"
                              disabled = {agente.version!=0 ? false : true}
                              onClick={() => {
                                setAgenteDetalle(agente.idAgente);
                                setFechaBuscar(agente.fecha);
                                setAgenteMonto(Number(agente.monto))
                                setMostrarDetalle(true);
                              }}
                            >
                              <Eye size={16} />
                            </Button>
                          </div>
                        </td>
                      </tr>
                    )})}
                  </tbody>
                </table>
            </div>
          )}

          {error2 && (
            <div className="p-4 mt-4 bg-destructive/10 border border-destructive rounded-lg text-destructive flex items-start gap-2">
              <AlertCircle className="w-5 h-5 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold">Error al cargar cierres en el rango establecido</p>
                <p className="text-sm">{error}</p>
              </div>
            </div>
          )}
        </CardContent>
      </Card>

      <AgregarObservacion
        isOpen={mostrarFormulario} 
        onClose={async () => {
          setMostrarFormulario(false);
          setCierreEditando(0);
        }}
        onGuardado={async() => {
          await getResumen();
          setMostrarFormulario(false);
        }}
        idEditando = {CierreEditando !== null ? Number(CierreEditando) : 0}
      />   
      <DetalleCierres
        isOpen={mostrarDetalle} 
        onClose={async () => {
          setMostrarDetalle(false);
          setAgenteDetalle(0);
          setAgenteMonto(0)
          setFechaBuscar("");
        }}
        idEditando= {agenteDetalle !== null ? Number(agenteDetalle) : 0}
        monto= {agenteMonto !== null ? Number(agenteMonto) : 0}
        fecha = {fechaBuscar}
      />   
      <DetalleCambiosCierre
        isOpen={mostrarCambiosCierre} 
        onClose={async () => {
          setMostrarCambiosCierre(false);
          setAgenteDetalle(0);
        }}
        idEditando= {agenteDetalle !== null ? Number(agenteDetalle) : 0}
      />   
    </div>
  );
}